import { render, staticRenderFns } from "./LeirikoskiVihkoInfo.vue?vue&type=template&id=6d4bf926"
import script from "./LeirikoskiVihkoInfo.vue?vue&type=script&lang=js"
export * from "./LeirikoskiVihkoInfo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports